import Mustache from "mustache";

jQuery(function ($) {
  "use strict";

  // copied to worksafeutils.js because it will be reused for the favourite.js code
  // this needs to be refactored to use utils.js
  // maybe later...
  var util = {
    supportLS: function () {
      if (typeof localStorage == "undefined") return false;
      else return true;
    },
    store: function (namespace, data) {
      if (arguments.length > 1) {
        return localStorage.setItem(namespace, JSON.stringify(data));
      } else {
        var store = localStorage.getItem(namespace);
        return (store && JSON.parse(store)) || [];
      }
    },
    getObjInArray: function (src, key, value) {
      for (var i = 0; i < src.length; i++) {
        if (src[i][key] === value) {
          return src[i];
        }
      }
      return null;
    },
    removeObjFromArray: function (src, key, value) {
      var dest = [];
      for (var i = 0; i < src.length; i++) {
        if (src[i][key] !== value) {
          dest.push(src[i]);
        }
      }
      return dest;
    },
  };

  var App = {
    settings: [],
    ratings: [], // all the ratings for this user [{ pageId: 1, rating: 0|1, comment: <Comment>, id: <PageFeedBackId> }, ...]
    pageRating: null, // rating for the visited page { pageId: 1, rating: 0|1, comment: <Comment>, id: <PageFeedBackId> }
    formIsOpen: false,
    msgValidationError: null,
    localStorageName: "worksafe-ratings",
    // ------------------------------------------------------------------------------
    // -----------------------           Init                     -------------------
    // ------------------------------------------------------------------------------
    init: function (feedbackSettings) {
      this.settings = feedbackSettings;
      this.cacheElements();
      this.ratings = util.store(this.localStorageName);
      // if page has already been rated, do not enable rating
      this.pageRating = util.getObjInArray(
        this.ratings,
        "pageId",
        this.settings.pageId
      );
      this.renderCue();
      this.bindEvents();
      this.$formHolder.height(0);
    },
    cacheElements: function () {
      this.feedbackFormTpl = $("#feedback-form-tpl").html();
      this.feedbackCueTpl = $("#feedback-cue-tpl").html();
      this.feedbackMsgTpl = $("#feedback-msg-tpl").html();
      this.feedbackCueStaticTpl = $("#feedback-cue-static-tpl").html();
      this.$cueHolder = $("#feedback-cue-holder");
      this.$formHolder = $(
        "#page-feedback-form-wrapper > .page-feedback-form"
      ).first();
    },
    bindEvents: function () {
      this.$cueHolder.on("click", "button", this.initFeedBack.bind(this));
      this.$formHolder.on(
        "click",
        "button.close-button",
        this.formClose.bind(this)
      );
      this.$formHolder.on(
        "click",
        "button.submit-button",
        this.sendFeedback.bind(this)
      );
    },
    // ------------------------------------------------------------------------------
    // -----------------------           Logic                    -------------------
    // ------------------------------------------------------------------------------
    initFeedBack: function (event) {
      var button = $(event.target);
      var id = null;
      if (this.pageRating && this.pageRating.id) {
        id = this.pageRating.id;
      }
      this.pageRating = {
        pageId: this.settings.pageId,
        rating: button.attr("data-value"),
        comment: null,
        id: id,
      };
      if (this.formIsOpen) {
        this.formToggle();
      } else {
        this.formOpen();
      }
      if (
        this.pageRating &&
        this.pageRating.rating === "1" &&
        this.pageRating.id === null
      ) {
        this.postPositiveFeedback();
      }
    },
    formToggle: function () {
      var $formHolder = this.$formHolder;
      this.$formHolder.stop().animate(
        { height: 0 },
        function () {
          this.formOpen();
        }.bind(this)
      );
    },
    formClose: function () {
      this.$formHolder.stop().animate(
        { height: 0 },
        function () {
          this.$formHolder.hide;
          this.formIsOpen = false;
        }.bind(this)
      );
    },
    formOpen: function () {
      this.renderForm();
      this.$formHolder
        .stop()
        .show()
        .animate({ height: this.$formHolder.prop("scrollHeight") });
      this.formIsOpen = true;
    },
    sendFeedback: function (event) {
      event.preventDefault();
      this.pageRating.comment = this.$formHolder.find("textarea").val();
      this.postFeedback();
    },
    // ------------------------------------------------------------------------------
    // -----------------------           Ajax                   -------------------
    // ------------------------------------------------------------------------------
    postFeedback: function () {
      this.renderMsg("loading", "Sending...");
      this.post(
        function () {
          this.renderCueStatic();
          this.renderMsg("", this.settings.msgSuccess);
          // remove rating in case it's been added by the postPositiveFeedback
          this.ratings = util.removeObjFromArray(
            this.ratings,
            "pageId",
            this.pageRating.pageId
          );
          this.ratings.push(this.pageRating);
          this.pageRating = {};
          util.store(this.localStorageName, this.ratings);
        }.bind(this),
        function () {
          this.renderMsg("error", this.settings.msgError);
        }.bind(this)
      );
    },
    // post positive feedback silently
    postPositiveFeedback: function () {
      this.post(
        function () {
          this.ratings.push(this.pageRating);
          util.store(this.localStorageName, this.ratings);
        }.bind(this)
      );
    },
    // post
    post: function (done, fail) {
      $.post(
        this.settings.rateLink,
        this.pageRating,
        function (id) {
          this.pageRating.id = id;
        }.bind(this)
      )
        .done(function () {
          if (typeof done === "function") {
            done();
          }
        })
        .fail(function () {
          if (typeof fail === "function") {
            fail();
          }
        });
    },
    // ------------------------------------------------------------------------------
    // -----------------------           Render                   -------------------
    // ------------------------------------------------------------------------------
    renderForm: function () {
      var msgFeedback;
      var msgPlaceholder;
      if (this.pageRating && this.pageRating.rating === "1") {
        msgFeedback = this.settings.msgFeedbackPositive;
        msgPlaceholder = this.settings.msgPositivePlaceholder;
      } else {
        msgFeedback = this.settings.msgFeedbackNegative;
        msgPlaceholder = this.settings.msgNegativePlaceholder;
      }
      this.render(this.$formHolder, this.feedbackFormTpl, {
        msgFeedback: msgFeedback,
        msgPlaceholder: msgPlaceholder,
        msgValidationError: this.msgValidationError,
      });
    },
    renderCue: function () {
      this.render(this.$cueHolder, this.feedbackCueTpl, {
        settings: this.settings,
      });
    },
    renderCueStatic: function () {
      var classPositive = "selected";
      var classNegative = "selected";
      if (this.pageRating && this.pageRating.rating === "1") {
        classNegative = "not-" + classNegative;
      } else {
        classPositive = "not-" + classPositive;
      }
      classNegative = "page-feedback-cue__response--" + classNegative;
      classPositive = "page-feedback-cue__response--" + classPositive;
      this.render(this.$cueHolder, this.feedbackCueStaticTpl, {
        classPositive: classPositive,
        classNegative: classNegative,
      });
    },
    renderMsg: function (msgclass, msg) {
      this.render(this.$formHolder, this.feedbackMsgTpl, {
        msgclass: msgclass,
        msg: msg,
      });
    },
    render: function (element, template, parameters) {
      var rendered = Mustache.render(template, parameters);
      element.html(rendered);
    },
  };

  if (util.supportLS && typeof feedbackSettings !== "undefined") {
    App.init(feedbackSettings);
  }
});
